import React from 'react';
import { IconProps } from '../../Types';

export const IconWaxingSalon = (props: IconProps) => {
    return (
        <svg
            width='33'
            height='32'
            viewBox='0 0 33 32'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...props}
        >
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M2.625 15.0562C2.00368 15.0562 1.5 15.5598 1.5 16.1812V27.625C1.5 29.3509 2.89912 30.75 4.625 30.75H20.9719C22.6978 30.75 24.0969 29.3509 24.0969 27.625V16.1812C24.0969 15.5598 23.5933 15.0562 22.9719 15.0562H2.625ZM0.25 16.1812C0.25 14.8695 1.31332 13.8062 2.625 13.8062H22.9719C24.2836 13.8062 25.3469 14.8695 25.3469 16.1812V27.625C25.3469 30.0413 23.3882 32 20.9719 32H4.625C2.20876 32 0.25 30.0413 0.25 27.625V16.1812Z'
                fill='#0C6FF3'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M4.50757 11.9184C3.88625 11.9184 3.38257 12.4221 3.38257 13.0434V13.8061H22.2142L22.2142 13.0434C22.2142 12.4221 21.7105 11.9184 21.0892 11.9184H4.50757ZM2.13257 13.0434C2.13257 11.7317 3.19589 10.6684 4.50757 10.6684H21.0892C22.4009 10.6684 23.4642 11.7317 23.4642 13.0434L23.4643 14.4311C23.4643 14.5969 23.3984 14.7559 23.2812 14.8731C23.164 14.9903 23.005 15.0561 22.8393 15.0561H2.75757C2.41239 15.0561 2.13257 14.7763 2.13257 14.4311V13.0434Z'
                fill='#0C6FF3'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M6.52539 2.44488C6.52539 1.09462 7.62004 0 8.97033 0H16.6263C17.9766 0 19.0712 1.09456 19.0712 2.44488V5.64537C19.0712 7.0303 17.9485 8.153 16.5636 8.153C15.1787 8.153 14.056 7.0303 14.056 5.64537C14.056 4.9508 13.4929 4.38775 12.7983 4.38775C12.1038 4.38775 11.5407 4.9508 11.5407 5.64537V11.2934C11.5407 11.6386 11.2609 11.9184 10.9157 11.9184H7.15039C6.80521 11.9184 6.52539 11.6386 6.52539 11.2934V2.44488ZM8.97033 1.25C8.31037 1.25 7.77539 1.785 7.77539 2.44488V10.6684H10.2907V5.64537C10.2907 4.26045 11.4134 3.13775 12.7983 3.13775C14.1833 3.13775 15.306 4.26045 15.306 5.64537C15.306 6.33995 15.869 6.903 16.5636 6.903C17.2582 6.903 17.8212 6.33995 17.8212 5.64537V2.44488C17.8212 1.78494 17.2862 1.25 16.6263 1.25H8.97033Z'
                fill='#0C6FF3'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M17.8215 2.44489C17.8215 2.09971 18.1014 1.81989 18.4465 1.81989H30.3647C31.406 1.81989 32.2501 2.66402 32.2501 3.70532V4.38501C32.2501 5.42635 31.4059 6.27038 30.3647 6.27038H18.4465C18.1014 6.27038 17.8215 5.99056 17.8215 5.64539V2.44489ZM19.0715 3.06989V5.02039H30.3647C30.7156 5.02039 31.0001 4.73592 31.0001 4.38501V3.70532C31.0001 3.35438 30.7156 3.06989 30.3647 3.06989H19.0715Z'
                fill='#0C6FF3'
            />
        </svg>
    );
};
